module.exports = global["$"] = require("-!/home/runner/work/isocom/isocom/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 131
// module chunks = 0